import { t } from "@/lib/i18n/messages";
import { useAppContext } from "@/providers";

export function LanguageSwitcher() {
  const { locale, setLocale } = useAppContext();

  return (
    <section className="bg-card p-6 rounded-lg shadow-sm border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-indigo-50 dark:bg-indigo-900/20 flex items-center justify-center text-indigo-600">
          <span className="material-icons-outlined">translate</span>
        </div>
        <h2 className="text-lg font-bold">{t(locale, "languagePreferences")}</h2>
      </div>
      <div className="flex bg-muted p-1 rounded-xl">
        <button
          type="button"
          onClick={() => setLocale("ar")}
          className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all ${
            locale === "ar"
              ? "bg-primary text-white shadow-sm"
              : "text-foreground-secondary hover:bg-muted"
          }`}
        >
          {t(locale, "arabicLang")}
        </button>
        <button
          type="button"
          onClick={() => setLocale("en")}
          className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all ${
            locale === "en"
              ? "bg-primary text-white shadow-sm"
              : "text-foreground-secondary hover:bg-muted"
          }`}
        >
          {t(locale, "englishLang")}
        </button>
      </div>
    </section>
  );
}
